import * as Yup from 'yup'

export const initialValues = {
  rating: 5,
  comments: [],
}

export enum HostRatingReasons {
  APPLICANES = 'Dirty appliances',
  BATHROOM_FIXTURES = 'Dirty bathroom fixtures',
  CARPETS = 'Carpet or upholstery dirty/stained',
  FLOORS = 'Floors not cleaned',
  INSUFFICIENT_CLEANING = 'Insufficient evidence of cleaning',
  INSUFFICIENT_DUSTING = 'Insufficient evidence of dusting',
  MAINTENANCE = 'Unreported Maintenance Issues',
  ODORS = 'Odors',
  QUALITY = 'Unreported Quality Issues',
  SURFACES = 'Surfaces dirty',
  TRASH = 'Trash left in unit',
  UTILITIES = 'Unreported Utilities Issues',
  WALLS = 'Walls not cleaned',
}

export const formSchema = Yup.object().shape({
  rating: Yup.number().required().min(1).max(5).positive(),
  comments: Yup.mixed().when('rating', {
    is: (rating) => rating < 5,
    then: () =>
      Yup.array()
        .of(
          Yup.object().shape({
            label: Yup.string().required(),
            value: Yup.string().required(),
          }),
        )
        .min(1),
    otherwise: () =>
      Yup.array().of(
        Yup.object().shape({
          label: Yup.string().required(),
          value: Yup.string().required(),
        }),
      ),
  }),
})

export type Option = {
  label: string
  value: string
}
export type Options = Array<Option>

export interface FormValuesType {
  comments: Options
  rating: number
}
